<template>
  <v-card class="main-content elevation-1" rounded="lg">
    <v-card-title class="main-content-title">
      <div class="main-content-title-left">
        <v-img class="main-content-image" :src="require(`@/assets/images/icons/${imgSrc}`)" />
        <span>{{ title }}</span>
      </div>
      <div class="main-content-title-right">
        <slot name="button" />
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-container class="main-content-container" fluid>
      <slot name="content" />
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "MainContentLayout",
  props: ["title", "imgSrc"],
  data() {
    return {

    }
  }
}
</script>

<style lang="scss">
.main-content {
  background-color: #f8f8f8 !important;
  .main-content-title.v-card__title {
    font-size: min(5vw, 22px);
    font-weight: bold;
  }
  .main-content-title {
    display: flex;
    justify-content: space-between;
    .main-content-title-left {
      display: flex;
      justify-content: flex-start;
      .main-content-image {
        max-width: 30px;
        margin-right: 5px;
      }
    }
    .main-content-title-right {
    }
  }
  .main-content-container {
    padding: 16px;
    height: 40vw;
    max-height: 400px;
    min-height: 200px;

    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: stretch;
  }
}
</style>